export default __webpack_public_path__ + "static/media/Prophecy_Hk.cb88dda9.webp";